export { CustomerPageWrapper } from './CustomerPageWrapper';
export { PurchaseWrapper } from './PurchaseWrapper';
